export default __webpack_public_path__ + "static/media/lake-peaceful.0beb2ccf.jpg";